import { gql } from "gql";

export const GET_ALL_DYNAMIC_PROCESSES = gql(/* GraphQL */ `
  query GetAllDynamicProcesses {
    getAllDynamicProcesses {
      __typename
      id
      active
      name {
        value
      }
    }
  }
`);
